import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from '../envconf/envconf.service';

@Injectable({
  providedIn: 'root'
})
export class OrderReportService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/reports`;

  constructor(private readonly http: HttpClient) {}

  public getCommissionReport(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.endpoint}/download/ordercommission`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  public getOrdersNotServedReport(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.endpoint}/download/ordernotserved`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  public getOrdersCanceledReport(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.endpoint}/download/ordercanceled`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  public getOrdersFullReport(automakerId?: number): Observable<HttpResponse<Blob>> {
    const query = automakerId ? `?automakerId=${automakerId}` : '';
    return this.http.get(`${this.endpoint}/download/orderfull${query}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
